import axios from "axios";
import { appConstants } from "./appConstants";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { IdleAction } from "ReduxReducers/tokenGenerateTime";
import { generateToken, showResMsg } from "./generic";
import {
  captureWebsiteDocument,
  downloadWebsiteDocument,
} from "./documentPdf";

let axiosConfig = {
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
  },
};
let id;
if (JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")) !== null) {
  id = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))._id;
}

export const getDataOnScreen = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "quotation/fetchDetailsOnAddQuotationScreen",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getDataOnScreen===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const getEmailAndTemplateForQuotation = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  return axios
    .post(
      appConstants.baseURL + "quotation/fetchCustomerEmailWithTemplate",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getEmailAndTemplateForQuotation===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getContactsForQuotation = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  return axios
    .post(
      appConstants.baseURL + "quotation/fetchContactsForQuotation",
      { ...values, includeUnavailableContacts: true },
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getDataOnScreen===>",
        error?.response?.data?.Result_Message
      );
    })
    .finally(() => {
      dispatch(loadingAction(false));
    });
};
export const getItemsForQuotation = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  return axios
    .post(
      appConstants.baseURL + "quotation/fetchItemsForQuotation",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getDataOnScreen===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const PreviewQuotationDetails = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "quotation/previewQuotationDetails",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log(
        "error PreviewQuotationDetails===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const prepareQuotationEmail = () =>
  axios
    .post(
      `${appConstants.baseURL}quotation/prepareQuotationEmail`,
      {},
      {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` },
        timeout: 10000,
      }
    )
    .catch(() => null);

export const prepareQuotationEmailDocument = async (
  quotationID,
  preparedSnapshot
) => {
  try {
    const documentSnapshot =
      (preparedSnapshot && (await preparedSnapshot)) ||
      (await captureWebsiteDocument("quotation", quotationID));
    if (documentSnapshot) return { documentSnapshot };
  } catch (error) {
    console.warn("Using server quotation PDF fallback", error);
  }

  const response = await axios.post(
    `${appConstants.baseURL}quotation/downloadQuotation`,
    { _id: quotationID },
    {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` },
      timeout: 60000,
    }
  );
  const documentPdfBase64 =
    typeof response.data === "string"
      ? response.data
      : response.data?.data || response.data?.Result_Output;
  if (!documentPdfBase64) {
    throw new Error("The quotation PDF could not be prepared.");
  }
  return { documentPdfBase64 };
};

export const getQuotationDetailsByID = async (
  values,
  callBack,
  dispatch,
  errorCallBack
) => {
  dispatch(loadingAction(true));
  return axios
    .post(
      appConstants.baseURL + "quotation/fetchQuotationDetailsByID",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
      return res.data;
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getDataOnScreen===>",
        error?.response?.data?.Result_Message
      );
      if (typeof errorCallBack === "function") errorCallBack(error);
      return null;
    });
};
const saveQuotationRequest = async (
  action,
  values,
  callBack,
  dispatch,
  { showLoader = true } = {}
) => {
  if (showLoader) dispatch(loadingAction(true));
  return axios
    .post(appConstants.baseURL + `quotation/${action}`, values, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` },
      timeout: 30000,
    })
    .then(async (res) => {
      await callBack(res.data);
      dispatch(IdleAction(new Date()));
      return res.data;
    })
    .catch(async (error) => {
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      const failure = {
        Result_Status: false,
        Result_Message:
          error?.response?.data?.Result_Message ||
          error?.response?.data?.message ||
          (error.code === "ECONNABORTED"
            ? "Saving the quotation took too long. Please check the quotations list before trying again."
            : "The quotation could not be saved. Please try again."),
        Result_Output: error?.response?.data?.Result_Output,
      };
      await callBack(failure);
      return failure;
    })
    .finally(() => {
      if (showLoader) dispatch(loadingAction(false));
    });
};

export const SaveQuotation = (values, callBack, dispatch, options) =>
  saveQuotationRequest("addQuotation", values, callBack, dispatch, options);

export const UpdateQuotation = (values, callBack, dispatch, options) =>
  saveQuotationRequest("updateQuotation", values, callBack, dispatch, options);

export const getQuotationExpiryValues = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "quotation/fetchQuotationExpiryValues",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getDataOnScreen===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const downloadQuotation = async (values, callback, dispatch) => {
  return downloadWebsiteDocument("quotation", values, callback, dispatch);
};

export const viewQuotationDetails = async (
  values,
  callback,
  dispatch,
  errorCallback
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "quotation/viewQuotationByID",
      values,
      axiosConfig
    )
    .then((res) => {
      callback(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error viewQuotationDetails===>",
        error?.response?.data?.Result_Message
      );
      if (typeof errorCallback === "function") errorCallback(error);
    });
};
